import * as React from 'react';
import TreeTablePicker from 'components/inputs/TreeTablePicker/TreeTablePicker';
import { SelectionTreeT } from 'business/definitions';
import { styled } from '@mui/material/styles';
import { useContext } from 'react';
import { OrgChartHrContext } from 'routes/HumanResourcesModule/components/contexts/HumanResourcesContext';
import { useTranslation } from 'react-i18next';
import {
    GetNodeIdT,
    reduceSelection,
    unminifySelection,
} from 'helpers/treeHelpers';
import {
    reducedNodeIdToSelectionTree,
    selectionTreeToReducedNodeId,
} from 'components/inputs/TreeTablePicker/helpers';

const StyTreeTablePicker = styled(TreeTablePicker, {
    name: 'StyTreeTablePicker',
})(() => ({
    '& .MuiInputBase-root': {
        fontSize: '1rem',
        '& input': {
            maxWidth: '100%',
        },
    },
    '& .MuiInputAdornment-root': {
        margin: '1.2em 0em',
    },
}));

type SelectOrgChartProps = {
    selectedOrgChartHrsSoftwareIds: string[];
    setSelectedOrgChartHrsSoftwareIds: (
        selectedOrgChartHrsSoftwareIds: string[],
    ) => void;
};

export default function SelectorOrgChartHr({
    selectedOrgChartHrsSoftwareIds,
    setSelectedOrgChartHrsSoftwareIds,
}: SelectOrgChartProps) {
    const { t } = useTranslation();
    const orgChartHr = useContext(OrgChartHrContext);
    const getNodeId: GetNodeIdT = (node) => node.value;

    const reducedSelection = reduceSelection(
        orgChartHr,
        selectedOrgChartHrsSoftwareIds,
        getNodeId,
    ).map((el) => reducedNodeIdToSelectionTree(el, orgChartHr, getNodeId));

    const handleOrgChartChange = (selectedTree: SelectionTreeT[]) => {
        const reducedOrgChartHrsSoftwareIds = unminifySelection(
            orgChartHr,
            selectedTree.map(selectionTreeToReducedNodeId),
            getNodeId,
        ) as string[];
        setSelectedOrgChartHrsSoftwareIds(reducedOrgChartHrsSoftwareIds);
    };

    return (
        <StyTreeTablePicker
            gridOptions={orgChartHr}
            selectedValues={reducedSelection}
            isLoading={false}
            onChange={handleOrgChartChange}
            required
            scopeOptions={[]}
            placeholder={t('humanResources.orgChartHr')}
            title={t('humanResources.orgChartHr')}
            variant="outlined"
            inputLabel={t('humanResources.orgChartHr')}
        />
    );
}
